import b from 'b_';
import React, { useCallback, useEffect, useMemo, useRef } from 'react';

import ItemContent from '../__item-content/prep-lessons__item-content';
import ItemFooter from '../__item-footer/prep-lessons__item-footer';
import { LessonInfo, SimpleCallback } from '../../../typings';
import { useResizeDetector } from '../../../utils/hooks/useResizeDetector';

import './prep-lessons__item.scss';

export interface OwnProps {
    assignedWarning?: React.ReactNode | null;
    buttonTextId?: string;
    checked?: boolean;
    disabled?: boolean;
    endDate: Date | null;
    index: number;
    isHot?: boolean;
    lesson: LessonInfo;
    onLastPrepLessonRef?: (ref: React.ReactInstance | null, index: number) => void;
    onClick?: (lessonId: number) => void;
    onCheckboxChange?: SimpleCallback;
    shouldShowId?: boolean;
    shouldShowCheckbox?: boolean;
    shouldShowButton?: boolean;
    shouldShowNotPublishedLabel?: boolean;
    startDate: Date | null;
    tag?: string;
}

interface Props extends OwnProps {}

export const PrepLessonsItem = (props: Props) => {
    const { index, onLastPrepLessonRef } = props;
    const ref = useRef(null);
    const getSize = useCallback((el: HTMLElement) => el.offsetWidth, []);
    const [size] = useResizeDetector(ref, getSize);

    useEffect(() => {
        if (onLastPrepLessonRef) {
            onLastPrepLessonRef(ref.current, index);
        }
    }, [index, onLastPrepLessonRef, ref]);

    const handleClick = () => {
        const {
            onClick,
            lesson: { id },
        } = props;

        if (onClick) {
            onClick(id);
        }
    };

    const isCompactView = useMemo<boolean>(() => {
        return Boolean(size && size < 285);
    }, [size]);

    const {
        assignedWarning,
        buttonTextId,
        checked,
        disabled,
        isHot,
        lesson,
        onCheckboxChange,
        shouldShowButton,
        shouldShowCheckbox,
        shouldShowId,
        shouldShowNotPublishedLabel,
        tag,
    } = props;
    const { cover, coverTitle, name, id, problemsCount, published } = lesson;

    return (
        <div
            className={b('prep-lessons', 'item', {
                unpublished: shouldShowNotPublishedLabel && !published,
                disabled,
            })}
            onClick={!disabled ? handleClick : undefined}
            ref={ref}
        >
            <div className="prep-lessons__item-wrapper">
                <ItemContent
                    checked={checked}
                    coverFile={cover?.file}
                    coverTitle={coverTitle}
                    isHot={isHot}
                    name={name}
                    onCheckboxChange={onCheckboxChange}
                    published={published}
                    shouldShowCheckbox={shouldShowCheckbox}
                    shouldShowNotPublishedLabel={shouldShowNotPublishedLabel}
                    tag={tag}
                />
                <ItemFooter
                    buttonTextId={buttonTextId}
                    disabled={disabled}
                    id={id}
                    isCompactView={isCompactView}
                    problemsCount={problemsCount}
                    shouldShowButton={shouldShowButton}
                    shouldShowId={shouldShowId}
                />
            </div>
            {assignedWarning}
        </div>
    );
};

const component = PrepLessonsItem;

export default component;
